module.exports = __webpack_public_path__ + "ro.583d4688.svg";